export default () => {
  const unknownOverDoseCheckbox = $("#incident_report_overdose_detail_checkboxes_2");
  const overdoseDetailContainer = $("#incident_report_form_overdose_section");
  const allCheckboxes = overdoseDetailContainer.find('input[type="checkbox"]');

  const toggleCheckboxes = (isChecked) => {
    allCheckboxes.not(unknownOverDoseCheckbox).prop("checked", false);
    allCheckboxes.not(unknownOverDoseCheckbox).prop("disabled", isChecked);
  };

  if (unknownOverDoseCheckbox.prop("checked")) {
    toggleCheckboxes(true);
  }

  unknownOverDoseCheckbox.on("change", function () {
    toggleCheckboxes(this.checked);
  });
};
